import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../stem-core/src/ui/Style";

import {WalletMerchantButton} from "../../../../common/MerchantButton";
import {Messages} from "../../../../Messages";
import {Link} from "../../../../../stem-core/src/ui/UIPrimitives";
import {UserPreferencesStore} from "../../../../State";
import {LoadingWidget} from "../../../ui/LoadingWidget";
import {WidgetRoutes} from "../../../WidgetRoutes";
import {SubscriptionOverview} from "./SubscriptionOverview";
import {ArticleDetails} from "./ArticleDetails";
import {apiReactivateSubscription} from "../../../../../client/state/SubscriptionStore";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {startSubscriptionFlow} from "../../../../panel/flows/startFlow";
import {PANEL_VARIANT} from "../../../../../blink-sdk/Constants";


export class SubscriptionIndexStyle extends StyleSheet {
    @styleRule
    title = {
        fontWeight: "lighter",
        fontSize: 20,
        textAlign: "center",
    };

    @styleRule
    button = {
        marginTop: 18,
        width: "100%",
    };

    @styleRule
    secondaryButton = {
        userSelect: "none",
        margin: "6px auto 0",
        padding: "6px 18px",
        width: this.themeProps.FIT_CONTENT,
        cursor: "pointer",
        transition: ".2s ease",
        fontSize: 14,
        display: "block",
        color: this.themeProps.MERCHANT_BUTTON_SECONDARY_COLOR,
        opacity: 0.8,
        ":hover": {
            color: this.themeProps.MERCHANT_BUTTON_SECONDARY_HOVER,
            opacity: 1,
        },
        fontWeight: "initial",
    };

    @styleRule
    supportMerchantMessage = {
        fontSize: 16,
        lineHeight: 24,
        textAlign: "center",
        marginTop: 18,
    };
}


@registerStyle(SubscriptionIndexStyle)
@autoredraw(iFrameUserDataService, UserPreferencesStore)
export class SubscriptionIndex extends UI.Element {
    async reactivateSubscription() {
        await LoadingWidget.merchantLoad(() => {
            // TODO handle API error.
            apiReactivateSubscription(iFrameUserDataService.getActiveSubscription().id);
        });
    }

    render() {
        return [
            this.renderSubscriptionSection(),
            this.renderPrimaryButton(),
            this.renderSecondaryButton(),
        ];
    }

    renderSubscriptionSection() {
        const subscription = iFrameUserDataService.getActiveSubscription();
        return subscription ? <SubscriptionOverview subscription={subscription}/> : [
            <ArticleDetails/>,
            <div className={this.styleSheet.supportMerchantMessage}>{Messages.considerSubscribing}</div>
        ];
    }

    renderSecondaryButton() {
        const {styleSheet} = this;

        return iFrameMerchantService.getMerchant().allowPurchases ?
            <Link href={WidgetRoutes.AUTOPAY} className={styleSheet.secondaryButton}
                  value={UserPreferencesStore.getPreferences()?.autoPayEnabled ? Messages.manageAutopay : Messages.setupAutopay}
            /> : null;
    }

    renderPrimaryButton() {
        const {styleSheet} = this;

        if (iFrameUserDataService.getActiveSubscription()) {
            return iFrameUserDataService.getActiveSubscription().isActiveButCanceled() ?
                <WalletMerchantButton onClick={() => this.reactivateSubscription()} className={styleSheet.button}>
                    {Messages.reactivate}
                </WalletMerchantButton> :
                <WalletMerchantButton onClick={() => startSubscriptionFlow(PANEL_VARIANT.editRecurring)}
                                className={styleSheet.button}>
                    {Messages.manageSubscription}
                </WalletMerchantButton>;
        }

        return <WalletMerchantButton onClick={() => startSubscriptionFlow()} className={styleSheet.button}>
            {Messages.subscribe}
        </WalletMerchantButton>;
    }
}
